import axios, { AxiosResponse } from 'axios';

export default {
    initPayment: (data: any) => axios.post('/services/isnaportalsync/open-api/payment/init', data),
    paymentStatus: (data: any) =>
        axios.post('/services/isnaportalsync/open-api/payment/status', data),
    kdpStatus: (params: any) => axios.post('/services/isnaportalsync/open-api/kdp' + params),
    checkKkmRegistry: (params: any) =>
        axios.post('/services/isnaportalsync/open-api/kkm-state-registry?' + params),
    upcomingPayments: (params: string, tokenStr: string) =>
        axios.get(`/services/isnaportalsync/api/upcoming-payments` + params, {
            headers: { Authorization: `${tokenStr}` },
        }),
};
